import React from "react";
import './Fleets.css';
import AIheader from "../../RentAI/AIheader";
import Footer from "../../../Component/Footer/Footer";



const Fleets = ()=> {

    return (
        <>
            <AIheader/>

            {/* START techBannerMain */}
            <section className='techBannerMain'>
                <div className='container'>
                    <div className='techBannerOuter'>
                        <div className='row justify-content-center'>
                            <div className='col-lg-10 col-md-12 col-sm-12 col-12'>
                                <div className='techBannerInner'>
                                    <h1><img className='img-fluid' src="/img/Technology/rentid_logo_white.svg" alt="rent id"/> Fleets</h1>
                                    <p>Fleets of all sizes <br/>are welcome.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* END techBannerMain */}
 
             {/* START fleetsPageMain */}
             <section className="fleetsPageMain">
                <div className="container">
                    {/* START 1 */}
                    <div className="fleetsPageOuter"> 
                        <div className='row align-items-center'>
                            <div className='col-xl-5 col-lg-4 col-md-4 col-sm-12 col-12'>
                                <div className='fleetsPageLeft'>
                                <img className="pie" src="/img/Fleet/pie.svg" alt="car"/>
                                    <small>FLEET SIZE</small>
                                    <div className='fleetsPageHeading'>
                                        <img width="30px" src="/img/Fleet/car_sky.svg" alt="car"/>
                                        <h2>1 - 5 vehicles</h2>
                                    </div>
                                    <p>Getting started</p>
                                    <h3>What I need to know</h3>
                                    <a className="btn btnBlue" href="/fleet-5">Explore More</a>
                                </div>
                            </div>
                            <div className='col-xl-7 col-lg-8 col-md-8 col-sm-12 col-12'>
                                <div className='fleetsPageRight'>
                                    <figure>
                                        <img className="img-fluid" src="/img/Fleet/fleets_page_1.png" alt="1 - 5 vehicles"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* START 2 */}
                    <div className="fleetsPageOuter"> 
                        <div className='row align-items-center'>
                            <div className='col-xl-5 col-lg-4 col-md-4 col-sm-12 col-12'>
                                <div className='fleetsPageLeft'>
                                <img className="pie" src="/img/Fleet/pie_2.svg" alt="car"/>
                                    <small>FLEET SIZE</small>
                                    <div className='fleetsPageHeading'>
                                        <img width="30px" src="/img/Fleet/car_sky.svg" alt="car"/>
                                        <h2>6 - 25 vehicles</h2>
                                    </div>
                                    <p>Growing Fleets</p>
                                    <h3>What’s the next step</h3>
                                    <a className="btn btnBlue" href="/fleet-25">Explore More</a>
                                </div>
                            </div>
                            <div className='col-xl-7 col-lg-8 col-md-8 col-sm-12 col-12'>
                                <div className='fleetsPageRight'>
                                    <figure>
                                        <img className="img-fluid" src="/img/Fleet/fleets_page_2.webp" alt="6 - 25 vehicles"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* START 3 */}
                    <div className="fleetsPageOuter"> 
                        <div className='row align-items-center'>
                            <div className='col-xl-5 col-lg-4 col-md-4 col-sm-12 col-12'>
                                <div className='fleetsPageLeft'>
                                <img className="pie" src="/img/Fleet/pie_3.svg" alt="car"/>
                                    <small>FLEET SIZE</small>
                                    <div className='fleetsPageHeading'>
                                        <img width="30px" src="/img/Fleet/car_sky.svg" alt="car"/>
                                        <h2>26 - 50 vehicles</h2>
                                    </div>
                                    <p>Scaleable Solutions </p>
                                    <h3>Leveraging Automation</h3>
                                    <a className="btn btnBlue" href="/fleet-50">Explore More</a>
                                </div>
                            </div>
                            <div className='col-xl-7 col-lg-8 col-md-8 col-sm-12 col-12'>
                                <div className='fleetsPageRight'>
                                    <figure>
                                        <img className="img-fluid" src="/img/Fleet/fleets_page_3.webp" alt="26 - 50 vehicles"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>


                    {/* START 4 */}
                    <div className="fleetsPageOuter"> 
                        <div className='row align-items-center'>
                            <div className='col-xl-5 col-lg-4 col-md-4 col-sm-12 col-12'>
                                <div className='fleetsPageLeft'>
                                <img className="pie" src="/img/Fleet/pie_4.svg" alt="car"/>
                                    <small>FLEET SIZE</small>
                                    <div className='fleetsPageHeading'>
                                        <img width="30px" src="/img/Fleet/car_sky.svg" alt="car"/>
                                        <h2>100+ Vehicles</h2>
                                    </div>
                                    <p>Data-backed decions</p>
                                    <h3>Enterprise Level Support</h3>
                                    <a className="btn btnBlue" href="/fleet-100">Explore More</a>
                                </div>
                            </div>
                            <div className='col-xl-7 col-lg-8 col-md-8 col-sm-12 col-12'>
                                <div className='fleetsPageRight'>
                                    <figure>
                                        <img className="img-fluid" src="/img/Fleet/fleets_page_4.webp" alt="100+ Vehicles"/>
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* END 4 */}

                </div>
            </section>
            {/* END fleetsPageMain */} 
     
            <Footer/>
        </>
    )
}

export default Fleets;